import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 md:gap-12 mb-8 sm:mb-12">
          {/* About */}
          <div className="col-span-2 md:col-span-1">
            <img 
              src="https://static.readdy.ai/image/8c75b34306599e28cafd501142ec58d6/6544712b4051e0bdfd79201f42094c9a.png" 
              alt="Kingdom Bridge Mission Logo" 
              className="h-10 sm:h-12 w-auto mb-3 sm:mb-4 brightness-0 invert"
            />
            <p className="text-xs sm:text-sm text-white/90 leading-relaxed">
              나라와 나라, 도시와 도시, 교회와 교회를 연결하는 영적 네트워킹
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm sm:text-base md:text-lg font-bold mb-3 sm:mb-4">바로가기</h4>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-xs sm:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  단체 소개
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('ministries')}
                  className="text-xs sm:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  주요 사역
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('partner-churches')}
                  className="text-xs sm:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  협력교회 및 선교지
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('field-news')}
                  className="text-xs sm:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Field News
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('inquiry')}
                  className="text-xs sm:text-sm text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  문의하기
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm sm:text-base md:text-lg font-bold mb-3 sm:mb-4">연락처</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-sm sm:text-lg mr-1.5 sm:mr-2 mt-0.5 flex-shrink-0"></i>
                <a href="tel:010-8524-9200" className="text-xs sm:text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  010-8524-9200
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-sm sm:text-lg mr-1.5 sm:mr-2 mt-0.5 flex-shrink-0"></i>
                <a href="mailto:svkdavid@hanmail.net" className="text-xs sm:text-sm text-white/90 hover:text-white transition-colors cursor-pointer break-all">
                  svkdavid@hanmail.net
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-sm sm:text-base md:text-lg font-bold mb-3 sm:mb-4">소셜 미디어</h4>
            <div className="flex flex-wrap gap-2 sm:gap-3">
              <a 
                href="https://www.facebook.com/profile.php?id=100002398088088" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-base sm:text-xl"></i>
              </a>
              <a 
                href="https://www.instagram.com/kbm_2025" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base sm:text-xl"></i>
              </a>
              <a 
                href="https://www.youtube.com/@bridgemission-2025" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-youtube-fill text-base sm:text-xl"></i>
              </a>
              <a 
                href="https://pf.kakao.com/loveslovakia" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-10 sm:h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition-colors cursor-pointer"
              >
                <i className="ri-kakao-talk-fill text-base sm:text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 sm:pt-8 border-t border-white/20">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
            <p className="text-xs sm:text-sm text-white/80 text-center sm:text-left">
              © 2026 킹덤브릿지미션. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link 
                to="/admin/login"
                className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
              >
                관리자
              </Link>
              <a 
                href="https://readdy.ai/?ref=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-xs sm:text-sm text-white/80 hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-xs sm:text-sm text-white/80 text-center sm:text-left">
              © 2025 한국교회선교연합회. All rights reserved.
            </p>
            <div className="flex items-center gap-3 sm:gap-4">
              <Link 
                to="/admin/login"
                className="text-xs sm:text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
              >
                관리자
              </Link>
              <a
                href="https://www.facebook.com/profile.php?id=61572046088854"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-base sm:text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/kbm_2025"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com/@bridgemission-2025"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="YouTube"
              >
                <i className="ri-youtube-fill text-base sm:text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
